import type { PlayerProfile } from '@shared/auth/types';

function isAccountSuspendedStatus(status: PlayerProfile['status'] | null | undefined): boolean {
  return status === 'SUSPENDED' || status === 'AML_SUSPENDED';
}

export { isAccountSuspendedStatus };
